<template>
    <v-flex>
        <ul>
            <div class="text-h6 my-4">Log</div>
            <li class="mb-2"  v-for="log in logs" v-bind:key="log.id">
                {{ log.message }}
            </li>
        </ul>
    </v-flex>
</template>

<script>
import { EventBus } from "@/Event";

export default {
  data() {
    return {
      logCount: 0,
      logs: []
    };
  },

  created() {
    EventBus.$on("newLog", (message) => {
      this.logs.push({ id: this.logCount, message: message });
      this.logCount += 1;
    });
  }
};
</script>

<style scoped>

</style>
